import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { connect } from "react-redux";
import DOMPurify from "dompurify";
import PopleadsButton from "app/popleads/components/ui-kit/Button";

function modal(props) {
    function SimpleModal() {
        const [show] = useState(true);

        const handleClose = (resp) => {
            props.onClose(resp);
        };

        function createBodyHTML(html) {
            // Always sanitize user input before rendering to DOM with dangerouslySetInnerHTML
            return { __html: DOMPurify.sanitize(props.body) };
        }

        return (
            <>
                <Modal
                    animation={false}
                    enforceFocus={false}
                    show={show}
                    onHide={() => handleClose("Cancel")}
                    size={props.size ? props.size : "md"}
                >
                    <Modal.Header closeButton>
                        <Modal.Title className="simpleModalTitle page-heading">{props.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className={`${props.className ? props.className : ""}`}>
                        {props.bodySvgUrl && (
                            <span className={`svg-icon-6x `}>
                                <SVG title="Info" src={toAbsoluteUrl(props.bodySvgUrl)} />
                            </span>
                        )}
                        <div
                            className={`simpleModalBody ${props.bodyClass ? props.bodyClass : ""}`}
                            dangerouslySetInnerHTML={createBodyHTML()}
                        ></div>
                        {props.errorMessage && <span className="errorMessage">{props.errorMessage}</span>}
                    </Modal.Body>
                    <Modal.Footer>
                        {props.buttonWithDisableColor && (
                            <button
                                className="disable-color font-size-14 font-weight-semibold cancelButton"
                                onClick={() => handleClose("Cancel")}
                            >
                                {props.buttonWithDisableColor}
                            </button>
                        )}
                        {props.primaryButton && (
                            <Button variant="primary" className="saveButtonModal" onClick={() => handleClose("OK")}>
                                {props.primaryButton}
                            </Button>
                        )}
                        {props.secondaryButton && (
                            <Button
                                variant="secondary"
                                className="cancelButtonModal"
                                onClick={() => handleClose("Cancel")}
                            >
                                {props.secondaryButton}
                            </Button>
                        )}
                        {props.secondaryConfirmButton && (
                            <Button variant="secondary" className="cancelButtonModal" onClick={() => handleClose("OK")}>
                                {props.secondaryConfirmButton}
                            </Button>
                        )}
                        {props.secondaryOutlinedButton && (
                            <PopleadsButton variant="primary" buttonStyle="option" onClick={() => handleClose("OK")}>
                                {props.secondaryOutlinedButton}
                            </PopleadsButton>
                        )}
                        {props.successOutlinedButton && (
                            <PopleadsButton variant="success" buttonStyle="option" onClick={() => handleClose("OK")}>
                                {props.successOutlinedButton}
                            </PopleadsButton>
                        )}
                        {props.primaryCancelButton && (
                            <PopleadsButton
                                variant="primary"
                                buttonStyle="option"
                                onClick={() => handleClose("Cancel")}
                            >
                                {props.primaryCancelButton}
                            </PopleadsButton>
                        )}
                        {props.dangerButton && (
                            <PopleadsButton variant="danger" buttonStyle="default" onClick={() => handleClose("OK")}>
                                {props.dangerButton}
                            </PopleadsButton>
                        )}
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    return <SimpleModal />;
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(modal);
